import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ParametrosSistemaService = /** @class */ (function () {
    function ParametrosSistemaService(httpClient) {
        this.httpClient = httpClient;
        this.httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        this.url = environment.URL_SICO + 'parametrosSistema/';
    }
    ParametrosSistemaService.prototype.consultarNumeroRemisiones = function () {
        return this.httpClient.post(this.url + 'consultarNumeroRemisiones/', this.httpOptions);
    };
    ParametrosSistemaService.prototype.consultarReferenciaFlete = function () {
        return this.httpClient.post(this.url + 'consultarReferenciaFlete/', this.httpOptions);
    };
    ParametrosSistemaService.prototype.urlPdfPromociones = function () {
        return this.httpClient.post(this.url + 'urlPdfPromociones/', this.httpOptions);
    };
    ParametrosSistemaService.prototype.actualizarUrlPdfPromociones = function (request) {
        return this.httpClient.post(this.url + 'actualizarUrlPdfPromociones/', request, this.httpOptions);
    };
    ParametrosSistemaService.prototype.sucursalObsequio = function () {
        return this.httpClient.get(this.url + 'sucursalObsequio/', this.httpOptions);
    };
    ParametrosSistemaService.prototype.sucursalModifica = function () {
        return this.httpClient.get(this.url + 'sucursalModifica/', this.httpOptions);
    };
    ParametrosSistemaService.prototype.gruposDescuento = function () {
        return this.httpClient.get(this.url + 'gruposDescuento/', this.httpOptions);
    };
    ParametrosSistemaService.ngInjectableDef = i0.defineInjectable({ factory: function ParametrosSistemaService_Factory() { return new ParametrosSistemaService(i0.inject(i1.HttpClient)); }, token: ParametrosSistemaService, providedIn: "root" });
    return ParametrosSistemaService;
}());
export { ParametrosSistemaService };
